export const cheatsheetDetailPage = () =>
  import("./CheatsheetDetailPage").then((m) => ({ Component: m.CheatsheetDetailPage }));
